<template>
  <div class="br-subleft overflow-y-auto" :data-min="status">
    <div>
      <h6
        class="
          tx-uppercase tx-10 tx-mont tx-spacing-1
          mg-t-10
          pd-x-10
          tx-white-7
        "
      >
        {{ $t("warehouse.条件筛选") }}
      </h6>
      <div class="mg-t-10 pd-x-10 mg-b-40">
        <div class="mg-b-15 form-group">
          <input
            type="text"
            :placeholder="$t('warehouse.仓库名称')"
            class="form-control form-control-dark tx-14"
            @keyup.enter="filtrate()"
            v-model.trim="name"
          />
        </div>
        <div class="mg-b-15 form-group">
          <input
            type="text"
            :placeholder="$t('warehouse.SKU名称')"
            class="form-control form-control-dark tx-14"
            @keyup.enter="filtrate()"
            v-model.trim="skuName"
          />
        </div>
        <div class="mg-b-15 form-group">
          <input
            type="text"
            :placeholder="$t('product.SKU编号')"
            class="form-control form-control-dark tx-14"
            @keyup.enter="filtrate()"
            v-model.trim="skuCode"
          />
        </div>
        <div class="datepicker-group form-group mg-b-15">
          <div class="input-group">
            <span class="input-group-addon"
              ><i class="icon ion-calendar tx-16 lh-0 op-6"></i
            ></span>
            <input
              v-model="dateFrom"
              data-id="datepicker-from"
              type="text"
              class="form-control-dark form-control fc-datepicker"
              :placeholder="$t('financial.起始日期')"
            />
          </div>
          <div class="input-group">
            <span class="input-group-addon"
              ><i class="icon ion-calendar tx-16 lh-0 op-6"></i
            ></span>
            <input
              v-model="dateTo"
              data-id="datepicker-to"
              type="text"
              class="form-control form-control-dark fc-datepicker"
              :placeholder="$t('financial.截止日期')"
            />
          </div>
        </div>
      </div>
    </div>
    <button
      class="
        btn btn-primary search btn-block
        tx-uppercase tx-11 tx-spacing-2 tx-medium
      "
      @click="filtrate()"
    >
      {{ $t("dashboard.筛 选") }}
    </button>
    <!-- todo3-仓库流水管理 -->
    <button
      @click="batchSearch('stock-movement')"
      class="
        btn btn-primary batchSearch btn-block
        tx-uppercase tx-11 tx-spacing-2 tx-medium
      "
    >
      {{ $t("distributor.批量搜索") }}
    </button>
  </div>
</template>

<script>
export default {
  props: [
    "status",
    "keyName",
    "keySkuName",
    "keySkuCode",
    "keyDateFrom",
    "keyDateTo",
  ],
  data() {
    return {
      name: "",
      skuName: "",
      skuCode: "",
      dateFrom: "",
      dateTo: "",
    };
  },
  watch: {
    keyName() {
      this.name = this.keyName;
    },
    keySkuName() {
      this.skuName = this.keySkuName;
    },
    keySkuCode() {
      this.skuCode = this.keySkuCode;
    },
    keyDateFrom() {
      this.dateFrom = this.keyDateFrom;
    },
    keyDateTo() {
      this.dateTo = this.keyDateTo;
    },
  },
  mounted() {
    this.datepickerSelect();
    $(".overflow-y-auto").perfectScrollbar();
    if (this.status) {
      $(".overflow-y-auto").perfectScrollbar("destroy");
    } else {
      $(".overflow-y-auto").perfectScrollbar();
    }
  },
  updated() {
    this.datepickerSelect();
    $(".overflow-y-auto").perfectScrollbar();
    if (this.status) {
      $(".overflow-y-auto").perfectScrollbar("destroy");
    } else {
      $(".overflow-y-auto").perfectScrollbar();
    }
  },
  methods: {
    batchSearch(key){
      this.$emit('batchSearch', key)
    },
    datepickerSelect() {
      let vm = this;
      $(".br-subleft [data-id=datepicker-from]").each(function () {
        $(this).datepicker({
          numberOfMonths: 1, //显示月的数量
          dateFormat: "yy-mm-dd", //日期格式化
          onClose: function (selectedDate) {
            $(this)
              .parents(".datepicker-group")
              .find($("[data-id=datepicker-to]"))
              .datepicker("option", "minDate", selectedDate);
          },
          onSelect: function (selectedDate) {
            vm.dateFrom = selectedDate;
          },
        });
      });
      $(".br-subleft [data-id=datepicker-to]").each(function () {
        $(this).datepicker({
          numberOfMonths: 1, //显示月的数量
          dateFormat: "yy-mm-dd", //日期格式化
          onClose: function (selectedDate) {
            $(this)
              .parents(".datepicker-group")
              .find($("[data-id=datepicker-from]"))
              .datepicker("option", "maxDate", selectedDate);
          },
          onSelect: function (selectedDate) {
            vm.dateTo = selectedDate;
          },
        });
      });
    },
    filtrate() {
      this.$emit(
        "filtrate",
        this.name,
        this.skuName,
        this.skuCode,
        this.dateFrom,
        this.dateTo
      );
    },
  },
};
</script>